<div #testDiv class="puzzle">
    <div class="left" [ngClass]="{ 'active-left': isTestDivScrolledIntoView }">
        <h2>MISSÃO</h2> 
    </div>
    <div class="right" [ngClass]="{ 'active-right': isTestDivScrolledIntoView }">
        Desenvolver soluções integradas e responsivas de logística e desembaraço aduaneiro, voltadas para a gestão de qualidade em atendimento e na prestação de serviços personalizados aos nossos clientes e parceiros comerciais despertando a confiança e credibilidade.
    </div>
</div>
